// src/App.js
import React from 'react';
import './App.css';
import CocktailSearch from './CocktailSearch';


function App() {
  return (
    <div className="App">
      < CocktailSearch />
    </div >
  );
}

export default App;

